import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { XpoAuthenticationGuard } from '@xpo/ngx-auth';
import { ImageSearchComponent } from './components/image-search/image-search.component';
import { ImageUploadComponent } from './components/image-upload/image-upload.component';
import { NotAuthorizedComponent } from './components/not-authorized/not-authorized.component';
import { RouterUriComponents } from './enums/router-uri-components.enum';
import { RoleCheckGuard } from './guards/role-check-guard';
import { OsdXpoLtlAuthenticationService } from './ng-migration/osd-auth.service';

const canActivate = [XpoAuthenticationGuard, OsdXpoLtlAuthenticationService];

export const RouterDefinitions: Routes = [
  {
    path: RouterUriComponents.NOT_AUTHORIZED_PAGE,
    component: NotAuthorizedComponent,
    canActivate,
  },
  {
    path: RouterUriComponents.DASHBOARD,
    component: ImageSearchComponent,
    canActivate,
  },
  {
    // path:  `${RouterUriComponents.IMAGE_UPLOAD_PAGE}/:${RouterParams.FILE_UPLOAD_EVENT}`,
    path: RouterUriComponents.IMAGE_UPLOAD_PAGE,
    component: ImageUploadComponent,
    canActivate,
  },
  {
    path: RouterUriComponents.OVERAGE,
    component: ImageSearchComponent,
    canActivate,
  },
  {
    path: 'salvage/:id',
    loadChildren: () => import('./components/salvage/salvage.module').then(m => m.SalvageModule),
    canActivate,
  },
  {
    path: RouterUriComponents.SALVAGE,
    loadChildren: () => import('./components/salvage/salvage.module').then(m => m.SalvageModule),
    canActivate,
  },
  {
    path: '',
    redirectTo: `/${RouterUriComponents.OVERAGE}`,
    pathMatch: 'full',
  },
  { path: '**', redirectTo: RouterUriComponents.OVERAGE, pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(RouterDefinitions, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule],
  providers: [RoleCheckGuard],
  declarations: [],
})
export class AppRoutingModule {}
